import { useQuery } from "react-query";

import { IParamsPositions } from "~/entity/Positions/model/schema";

import { usePositions } from "./usePositions";

export const POSITIONS_QUERY_KEY = "positions";

export const useGetPositions = (params: IParamsPositions) => {
  const { positionsGet } = usePositions();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [POSITIONS_QUERY_KEY, params],
    queryFn: () => positionsGet(params),
  });

  return {
    positions: data?.data?.positions,
    total: data?.data?.total,
    totalPages: data?.data?.totalPages,
    isLoading,
    isError,
    refetch,
  };
};
